import React, { FC, PropsWithChildren } from 'react'

import { styled } from 'styled-components'

import CardSectionListRow from './CardSectionListRow'

type CardSectionListProps = PropsWithChildren<{
  leftWidth?: string
}>

const CardSectionList: FC<CardSectionListProps> = ({ children, leftWidth }) => {
  const kiddos = React.Children.toArray(children).filter((child) => child)

  const list = kiddos.map((child, index) => {
    const props = { isFirst: index === 0, leftWidth }

    return child.type === CardSectionListRow ? (
      React.cloneElement(child, props)
    ) : (
      <CardSectionListRow key={`wrapped-${index}`} {...props}>
        {child}
      </CardSectionListRow>
    )
  })

  return <ContentContainer>{list}</ContentContainer>
}

export default CardSectionList

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
`
